import * as React from 'react';
import { useCallback } from 'react';
import cn from 'classnames';

import { useTheme } from '../../../../../theme';

export interface Props {
	variant?: 'variant_default' | 'lightBg' | 'onPhoto' | 'bigCircles';
	itemsCount: number;
	currentIndex: number;
	renderItem?: (index: number, isActive: boolean, onChange?: Props['onChange']) => React.ReactElement;
	className?: string;
	onChange?: (index: number) => void;
}

const Pagination: React.FC<Props> = props => {
	const { Pagination: theme } = useTheme('Shared');

	const renderItem = useCallback(
		(item: number, index: number) => {
			if (props.renderItem) {
				return props.renderItem(index, props.currentIndex === index, props.onChange);
			} else {
				return (
					<div
						onClick={() => (props.onChange ? props.onChange(index) : null)}
						data-active={props.currentIndex === index}
						className={cn(theme.item, { [theme.item_active]: props.currentIndex === index })}
						key={index}
					/>
				);
			}
		},
		[props.itemsCount, props.currentIndex, props.renderItem]
	);

	return (
		<div className={cn(theme.pagination, props.className, theme[props.variant])}>
			{new Array(props.itemsCount).fill(null).map(renderItem)}
		</div>
	);
};

export default Pagination;
